export default [
  {
    title: 'Dev Tools',
    icon: { icon: 'ic:outline-construction' },
    // Internal ops console — super admins only, in every environment (it ships on
    // production builds too). Non-super-admins never see it, dev included. The
    // /dev/* router guard enforces the same rule for direct URLs.
    superAdminOnly: true,
    children: [
      {
        title: 'OLAP Explorer',
        action: 'read',
        subject: 'Management',
        to: 'dev-olap-explorer',
        icon: { icon: 'ic:outline-table-view' },
      },
      {
        title: 'API Query',
        action: 'read',
        subject: 'Management',
        to: 'dev-api-query',
        icon: { icon: 'tabler-database-search' },
      },
      {
        title: 'Dev Access',
        action: 'read',
        subject: 'Management',
        to: 'dev-dev-access',
        icon: { icon: 'ic:outline-verified-user' },
        superAdminOnly: true,
      },
      {
        title: 'Dev Settings',
        action: 'read',
        subject: 'Management',
        to: 'dev-settings',
        icon: { icon: 'ic:outline-settings' },
      },
      {
        title: 'Campaigns',
        action: 'read',
        subject: 'Management',
        to: 'dev-campaigns',
        icon: { icon: 'ic:outline-campaign' },
        superAdminOnly: true,
      },
      {
        title: 'Billing',
        action: 'read',
        subject: 'Management',
        to: 'dev-billing',
        icon: { icon: 'ic:outline-credit-card' },
        superAdminOnly: true,
      },
      {
        title: 'Dayparting',
        action: 'read',
        subject: 'User',
        to: 'ppc-dayparting',
        icon: { icon: 'ic:outline-access-time' },
        envOnly: 'development',
      },
      {
        title: 'Trends',
        to: '',
        icon: { icon: 'ic:outline-trending-up' },
        disable: true,
      },
    ],
  },
];
